import dissoc from 'ramda/src/dissoc'

export default state => dissoc('manufacturerSpecificCameraModels', state)



// WEBPACK FOOTER //
// ./src/reducers/removeManufacturerSpecificCameras.js